/*jshint -W040, -W117 */
(function () {
    'use strict';

    angular
        .module('app.user')
        .component('userProfile',
        {
            bindings: {
                model: '<',
                editMode: '<',
                isExternal: '<',
                existingModel: '<',
                onFormValidationChange: '&'
            },
            templateUrl: 'app/user/profile/user.profile.component.html',
            controller: userProfileComponent,
            controllerAs: 'vm'
        });

    /* @ngInject */
    function userProfileComponent($q, userService, userProfileService, $timeout) {
        var vm = this;
        var emailHasBeenValidated = false;

        vm.$onInit = onInit();

        vm.departmentRoles = [];
        vm.locations = [];
        vm.jobTitles = [];

        vm.searchADUser = searchAdUser;
        vm.verifyEmailAddress = verifyEmailAddress;
        vm.onChange = onChange;
        vm.onRoleChanged = onRoleChanged;
        vm.onFormChangeOccured = onFormChangeOccured;

        function onInit() {
            var bRolePromise = userProfileService.getDepartmentRoles().then(function (result) {
                if (result.status === 200) {
                    vm.departmentRoles = result.data;
                }
            });

            var chPromise = userProfileService.getLocations().then(function (result) {
                if (result.status === 200) {
                    vm.locations = result.data;
                }
            });

            var jtPromise = userProfileService.getJobTitles().then(function (result) {
                if (result.status === 200) {
                    vm.jobTitles = result.data;
                }
            });

            var promises = [bRolePromise, chPromise, jtPromise];

            $q.all(promises).then(function () {
                onFormChangeOccured();
                setDropdownNames(vm.existingModel);
            });
        }

        function searchAdUser(searchValue) {
            if (!searchValue) { return; }

            emailHasBeenValidated = false;
            vm.model.hasSelection = false;

            return userService.searchADUser(searchValue).then(function (results) {
                emailHasBeenValidated = true;

                onFormChangeOccured();
                ATAC.hideLoader();
                if (results.status === 200) {
                    return results.data.map(function (user) {
                        return {
                            FirstName: user.FirstName,
                            LastName: user.LastName,
                            FullName: user.FullName,
                            Auth0UserId: user.Auth0UserId,
                            Email: user.Email
                        };
                    });                    
                }

                vm.form['Email Address'].$setValidity('emailNotSelected', false);
                return [];
            });
        }

        function verifyEmailAddress(searchValue) {
            if (!searchValue) { return; }

            emailHasBeenValidated = false;
            vm.onFormValidationChange({ isValid: false });

            return userService.EmailExistsOrIsDomainAccount(searchValue).then(function (results) {
                emailHasBeenValidated = true;

                ATAC.hideLoader();
                var data = results.status === 200 && results.data;

                vm.form['Email Address'].$invalid = data.EmailExists || data.IsAdEmail;
                vm.form['Email Address'].$setValidity('emailExists', !data.EmailExists);
                vm.form['Email Address'].$setValidity('emailIsAd', !data.IsAdEmail);

                onFormChangeOccured();
                return [];
            });
        }

        function onChange(model) {
            vm.model = angular.extend(vm.model, {
                FirstName: model.FirstName,
                LastName: model.LastName,
                FullName: model.FullName,
                Auth0UserId: model.Auth0UserId,
                Email: model.Email,
                hasSelection: model.hasSelection
            });

            $timeout(function () {
                onFormChangeOccured();
            }, 100);            
        }

        function onRoleChanged(role) {
            onFormChangeOccured();
        }

        function onFormChangeOccured() {
            var areSelectsValid = manuallyValidateUISelects();
            
            vm.onFormValidationChange({ isValid: vm.form.$valid && areSelectsValid });
        }

        function setDropdownNames(model) {
            var corporateHierarchyName =
                _.where(vm.locations, { CorporateHierarchyId: model.LocationRoleId })[0].CorporateHierarchyName;
            var departmentRoleName =
                _.where(vm.departmentRoles, { DepartmentRoleId: model.DepartmentRoleId })[0].DepartmentRoleName;
            var jobTitleName = _.where(vm.jobTitles, { JobTitleId: model.TitleRoleId })[0].JobTitleName;

            var updatedProperties = {
                CorporateHierarchyName: corporateHierarchyName,
                DepartmentRoleName: departmentRoleName,
                JobTitleName: jobTitleName
            };
            vm.existingModel = angular.extend(vm.existingModel, updatedProperties);
        }

        function manuallyValidateUISelects() {
            if (!vm.isExternal && !vm.editMode) {
                if (vm.model.hasSelection) {
                    vm.form['Email Address'].$setValidity('emailNotSelected', true);
                    return true;
                } else {
                    vm.form['Email Address'].$setValidity('emailNotSelected', false);
                    return false;
                }
            }

            if (!vm.editMode && !emailHasBeenValidated) {
                return false;
            }

            if (!vm.isExternal) {
                return vm.model.Email && vm.model.FirstName && vm.model.LastName;
            } else if (vm.model.LocationRoleId > 0 && vm.model.DepartmentRoleId > 0 && vm.model.TitleRoleId > 0) {
                return true;
            }

            return false;            
        }        
    }

})();
